const keycodes = {
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    LEFT: 37,
    END: 35,
    HOME: 36,
    SPACE: 32,
    RETURN: 13,
    ESCAPE: 27,
    TAB: 9,
    BACK_QUOTE: 192,
};

export default keycodes;
